export function padZero(value: number | null = 0, length: number = 2) {
  let valueString = value?.toString() || "0";
  while (valueString.length < length) {
    valueString = "0" + valueString;
  }
  return valueString;
}
